export const getLeftPanelConfig = () => {
  return {
    views: [
      {
        mask: {
          value: 'dd mmm yyyy',
        },
        id: {
          value: 'patientDetails',
        },
        title: {
          targetItem: {
            key: {
              key: 'labels.patientRecord.views.patientDetails.title',
            },
          },
        },
        fallbackTitle: {
          targetItem: {
            key: {
              key: 'labels.patientRecord.views.patientDetails.fallbackTitle',
            },
          },
        },
        type: {
          value: 'Form',
        },
        mode: {
          value: 'readWrite',
        },
        data: {
          value: 'patientDetailsView',
        },
        showAddIcon: {
          value: '',
        },
        showEditIcon: {
          value: '',
        },
        read: [
          {
            name: {
              value: 'read',
            },
            analytics: 'edit_view_patient',
            clkErrorLabel: {
              targetItem: {
                key: {
                  key: 'labels.patientRecord.views.patientDetails.read.clkErrorLabel',
                },
              },
            },
            errorLabel: {
              targetItem: {
                key: {
                  key: 'labels.patientRecord.views.patientDetails.read.errorLabel',
                },
              },
            },
            fieldLayout: {
              value: 'horizontal',
            },
            elements: [
              {
                id: 'cochlearId',
                label: {
                  targetItem: {
                    key: {
                      key: 'labels.common.cochlearId',
                    },
                  },
                },
                value: {
                  value: '{{accountId}}',
                },
              },
              {
                id: 'dateOfBirth',
                label: {
                  targetItem: {
                    key: {
                      key: 'labels.patientRecord.views.patientDetails.read.elements.dateOfBirth',
                    },
                  },
                },
                value: {
                  // Note: do NOT fix and revert back to dateOfBirth -> adaptive form does some automatic date formatting we don't want
                  value:
                    '{{#dateOfBirthFormatted}}{{dateOfBirthFormatted}}{{/dateOfBirthFormatted}}{{^dateOfBirthFormatted}}--{{/dateOfBirthFormatted}}',
                },
              },
              {
                id: 'phone',
                label: {
                  targetItem: {
                    key: {
                      key: 'labels.patientRecord.views.patientDetails.read.elements.phone',
                    },
                  },
                },
                value: {
                  value:
                    '{{#phoneNumber}}{{phoneNumber}}{{/phoneNumber}}{{^phoneNumber}}--{{/phoneNumber}}',
                },
              },
              {
                id: 'email',
                label: {
                  targetItem: {
                    key: {
                      key: 'labels.patientRecord.views.patientDetails.read.elements.email',
                    },
                  },
                },
                value: {
                  value:
                    "{{#email}}<a href='mailto:{{email}}' title='{{email}}' data-analytics='mailto_patient_view_patient'>{{email}}</a>{{/email}}{{^email}}--{{/email}}",
                },
              },
              {
                id: 'address',
                label: {
                  targetItem: {
                    key: {
                      key: 'labels.patientRecord.views.patientDetails.read.elements.address',
                    },
                  },
                },
                value: {
                  value:
                    '{{#street1}}  \t{{street1}} {{street2}} <br/>  {{/street1}}  {{^street1}}  \t{{#street2}}  \t\t{{street2}} <br/>  \t{{/street2}}  {{/street1}}  {{#city}}  \t{{city}} <br /> {{/city}}  {{#state}}  \t{{state}} {{postcode}} <br /> {{/state}}  {{^state}}  \t{{#postcode}}  \t\t {{postcode}} <br /> \t{{/postcode}}  {{/state}}  {{#country}}  \t{{country}}  {{/country}}',
                },
              },
              {
                id: 'accountDetails',
                label: {
                  targetItem: {
                    key: {
                      key: 'labels.patientRecord.views.patientDetails.read.elements.accountDetails',
                    },
                  },
                },
                value: {
                  value:
                    "{{accountDetails}} {{accountLinkSeparator}} <a href='#' class='ccl__email-verified'>{{emailVerified}}</a>",
                },
              },
            ],
          },
        ],
        edit: [
          {
            edit: {
              targetItem: {
                key: {
                  key: 'labels.patientRecord.views.patientDetails.edit.edit',
                },
              },
            },
            editIcon: {
              value: '',
            },
            analytics: 'edit_view_patient',
          },
        ],
        create: [],
      },
      {
        mask: {
          value: 'dd mmm, yyyy',
        },
        id: {
          value: 'associatedCarersView',
        },
        title: {
          targetItem: {
            key: {
              key: 'labels.patientRecord.views.associatedCarersView.title',
            },
          },
        },
        fallbackTitle: {
          targetItem: null,
        },
        type: {
          value: 'List',
        },
        mode: {
          value: 'readWrite',
        },
        data: {
          value: 'carersData',
        },
        showGlobalAdd: {
          value: '1',
        },
        showAddIcon: {
          value: '1',
        },
        showEditIcon: {
          value: '',
        },
        read: [
          {
            name: {
              value: 'read',
            },
            analytics: 'add_carer_view_patient',
            clkErrorLabel: {
              targetItem: {
                key: {
                  key: 'labels.patientRecord.views.associatedCarersView.read.clkErrorLabel',
                },
              },
            },
            errorLabel: {
              targetItem: {
                key: {
                  key: 'labels.patientRecord.views.associatedCarersView.read.errorLabel',
                },
              },
            },
            fieldLayout: {
              value: 'horizontal',
            },
            elements: [
              {
                id: 'name',
                label: {
                  targetItem: null,
                },
                value: {
                  value:
                    '<a href="javascript:void(0)" id="cr_view_{{accountId}}" data-id="{{accountId}}">{{firstName}} {{lastName}}</a>',
                },
              },
              {
                id: 'phone',
                label: {
                  targetItem: {
                    key: {
                      key: 'labels.patientRecord.views.associatedCarersView.read.elements.phone',
                    },
                  },
                },
                value: {
                  value:
                    '{{#phoneNumber}}{{phoneNumber}}{{/phoneNumber}}{{^phoneNumber}}--{{/phoneNumber}}',
                },
              },
              {
                id: 'email',
                label: {
                  targetItem: {
                    key: {
                      key: 'labels.patientRecord.views.associatedCarersView.read.elements.email',
                    },
                  },
                },
                value: {
                  value:
                    "{{#email}}<a href='mailto:{{email}}' title='{{email}}' data-analytics='mailto_carer_view_patient'>{{email}}</a>{{/email}}{{^email}}--{{/email}}",
                },
              },
              {
                id: 'address',
                label: {
                  targetItem: {
                    key: {
                      key: 'labels.patientRecord.views.associatedCarersView.read.elements.address',
                    },
                  },
                },
                value: {
                  value:
                    '{{#street1}}  \t{{street1}} {{street2}} <br/>  {{/street1}}  {{^street1}}  \t{{#street2}}  \t\t{{street2}} <br/>  \t{{/street2}}  {{/street1}}  {{#city}}  \t{{city}} <br /> {{/city}}  {{#state}}  \t{{state}} {{postcode}} <br /> {{/state}}  {{^state}}  \t{{#postcode}}  \t\t {{postcode}} <br /> \t{{/postcode}}  {{/state}}  {{#country}}  \t{{country}}  {{/country}}',
                },
              },
              {
                id: 'accountDetails',
                label: {
                  targetItem: {
                    key: {
                      key: 'labels.patientRecord.views.associatedCarersView.read.elements.accountDetails',
                    },
                  },
                },
                value: {
                  value:
                    "{{accountDetails}} {{accountLinkSeparator}} <a href='#' class='ccl__email-verified'>{{emailVerified}}</a>",
                },
              },
            ],
          },
        ],
        edit: [
          {
            edit: {
              targetItem: {
                key: {
                  key: 'labels.patientRecord.carers.add',
                },
              },
            },
            editIcon: {
              value: '',
            },
            analytics: 'add_carer_view_patient',
          },
        ],
        create: [
          {
            createLabel: {
              targetItem: {
                key: {
                  key: 'labels.patientRecord.views.associatedCarersView.create.createLabel',
                },
              },
            },
            createIcon: {
              value: '',
            },
          },
        ],
      },
      {
        mask: {
          value: 'mmmm dd yyyy',
        },
        id: {
          value: 'associatedClinicsView',
        },
        title: {
          targetItem: {
            key: {
              key: 'labels.patientRecord.views.associatedClinicsView.title',
            },
          },
        },
        fallbackTitle: {
          targetItem: null,
        },
        type: {
          value: 'List',
        },
        mode: {
          value: 'readWrite',
        },
        showGlobalAdd: {
          value: '1',
        },
        data: {
          value: 'associatedClinicData',
        },
        showAddIcon: {
          value: '1',
        },
        showEditIcon: {
          value: '',
        },
        read: [
          {
            name: {
              value: 'read',
            },
            analytics: 'add_clinic_view_patient',
            clkErrorLabel: {
              targetItem: {
                key: {
                  key: 'labels.patientRecord.views.associatedClinicsView.read.clkErrorLabel',
                },
              },
            },
            errorLabel: {
              targetItem: {
                key: {
                  key: 'labels.patientRecord.views.associatedClinicsView.read.errorLabel',
                },
              },
            },
            fieldLayout: {
              value: '',
            },
            elements: [
              {
                id: 'clinicName',
                label: {
                  targetItem: null,
                },
                value: {
                  value:
                    "<span class='ccl__text--body-text-bold'>{{clinicName}}</span>",
                },
              },
              {
                id: 'phone',
                label: {
                  targetItem: null,
                },
                value: {
                  value: '{{phoneNumber}}',
                },
              },
              {
                id: 'address',
                label: {
                  targetItem: null,
                },
                value: {
                  value:
                    '{{street1}} {{street2}} <br/> {{city}} {{state}} {{postcode}}<br/>{{country}}',
                },
              },
            ],
          },
        ],
        edit: [
          {
            analytics: 'add_clinic_view_patient',
          },
        ],
        create: [
          {
            createLabel: {
              targetItem: {
                key: {
                  key: 'labels.patientRecord.views.associatedClinicsView.create.createLabel',
                },
              },
            },
            createIcon: {
              value: '',
            },
          },
        ],
      },
    ],
  };
};

export const errorModeConfig = {
  codeLabel: 'Error code',
  errorResponse: '',
  mode: '',
  data: {
    submit: {
      image: {
        src: 'https://mss-p-007-delivery.sitecorecontenthub.cloud/api/public/content/9bfd65ed69994fa49be3ff1339ea9674?v=cc7c6ec3',
        alt: 'Bug.svg',
        width: '120',
      },
      title: "That's strange, it seems something went wrong.",
      text: 'We had a problem updating your details.<br />If you need immediate help, contact our customer support team on <a href="tel:+1-877-651-7001" class="ccl__text--interactive-text" data-nw-error-link="phoneNumber" data-nw-action="call">877-651-7001.</a>',
      buttons: [
        {
          name: 'tryAgain',
          variant: 'brand-primary',
          text: 'Try again',
          icon: '',
          link: '',
          action: 'retry-submit',
          useCallback: true,
        },
        {
          name: 'backToHome',
          variant: 'secondary',
          text: 'Cochlear home',
          icon: 'chevron-right',
          link: 'https://node.sit.cms.cochlear.cloud/us/en/home',
          action: 'link-cochlear-home',
          useCallback: false,
        },
      ],
    },
    read: {
      image: {
        src: 'https://mss-p-007-delivery.sitecorecontenthub.cloud/api/public/content/9bfd65ed69994fa49be3ff1339ea9674?v=cc7c6ec3',
        alt: 'Bug.svg',
        width: '120',
      },
      title: "That's strange, it seems something went wrong.",
      text: 'We’re working to fix the problem and we’ll be up and running soon.<br />If you need immediate help, contact our customer support team on <a href="tel:+1-877-651-7001" class="ccl__text--interactive-text" data-nw-error-link="phoneNumber" data-nw-action="call">877-651-7001.</a>',
      buttons: [
        {
          name: 'backToHome',
          variant: 'secondary',
          text: 'Cochlear home',
          icon: 'chevron-right',
          link: '/us/en/home',
          action: 'link-cochlear-home',
          useCallback: false,
        },
      ],
    },
  },
};
